import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-timeout-dialog',
  templateUrl: './timeout-dialog.component.html'
})
export class TimeoutDialogComponent implements OnInit {
  public timer: number = 60;

  constructor(public dialogRef: MatDialogRef<TimeoutDialogComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.startTimer();
  }

  private startTimer() {
    const timeInterval = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(timeInterval);
        this.dialogRef.close(false);
      }
    }, 1000);
  }

}
